import { api } from '@/lib/api-manager'

export async function startRequestReview(id: string) {
  const result = await api.patch(`v1/requests/request/${id}`)
  return result.data
}
